import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Session } from "@supabase/supabase-js";

export default function ProtectedRoute() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Get current session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="w-8 h-8 border-4 border-linkedin border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!session) {
    // Redirect to login but save the attempted location
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Admin Verification
  const adminEmailsString = import.meta.env.VITE_ADMIN_EMAILS || "";
  const adminEmails = adminEmailsString.split(",").map((email: string) => email.trim().toLowerCase());
  
  if (!adminEmails.includes(session.user.email?.toLowerCase() || "")) {
    // If logged in but not admin, maybe redirect to a generic error or logout
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 text-center p-4">
        <h1 className="text-2xl font-bold text-red-500 mb-2">Acesso Negado</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          Sua conta não possui privilégios de administrador.
        </p>
        <button 
          onClick={() => supabase.auth.signOut()}
          className="text-linkedin hover:underline"
        >
          Sair da conta
        </button>
      </div>
    );
  }

  return <Outlet />;
}
